import React from "react";
import { Modal, ModalBody } from "reactstrap";
import "../../assets/styles/deletePopup.css";

const ImageModal = ({
  isOpen,
  onClose,
  message,
  altText = "Preview",
  attachment,
}) => {
  const renderAttachment = () => {
    if (!attachment || !attachment.file || !attachment.type) {
      return <p>No attachment available.</p>;
    }

    if (attachment.type === "image") {
      return (
        <img
          src={attachment.file}
          alt={altText}
          style={{ maxWidth: "100%", maxHeight: "80vh" }}
        />
      );
    } else if (attachment.type === "pdf") {
      return (
        <iframe
          src={attachment.file}
          title="PDF Preview"
          width="100%"
          height="500px"
          style={{ border: "none", overflow: "auto" }}
          className="pdf-preview"
        />
      );
    } else {
      return <p>Unsupported attachment type.</p>;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="image-modal">
      <ModalBody>
        <div>
          <span>
            Message:
            <p style={{ fontWeight: "bold" }}>{message}</p>
          </span>
          <span>Attachment</span>
          <div style={{ marginTop: "10px" }}>{renderAttachment()}</div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ImageModal;
